function initMobileMenuAccordion() {
	const mobileMenu = document.querySelector('#mobile-menus');

	if (!mobileMenu) {
		return;
	}

	const items = mobileMenu.querySelectorAll(
		'.menu-item--depth-0.has-children'
	);

	const getControl = item => {
		return item.querySelector(
			':scope > .menu-item__link--depth-0, ' +
			':scope > .menu-item__label--depth-0'
		);
	};

	const getSubMenu = item => {
		return item.querySelector(
			':scope > .sub-menu--depth-0'
		);
	};

	const closeItem = item => {
		const control = getControl(item);

		item.classList.remove('is-open');

		if (control) {
			control.setAttribute(
				'aria-expanded',
				'false'
			);
		}
	};

	const closeOtherItems = currentItem => {
		items.forEach(item => {
			if (item !== currentItem) {
				closeItem(item);
			}
		});
	};

	items.forEach(item => {
		const control = getControl(item);
		const subMenu = getSubMenu(item);

		if (!control || !subMenu) {
			return;
		}

		/*
		 * Удаляем inline max-height,
		 * оставшийся от предыдущего JS.
		 */
		subMenu.style.removeProperty('max-height');

		control.setAttribute(
			'aria-expanded',
			'false'
		);
	});

	mobileMenu.addEventListener(
		'click',
		event => {
			const control = event.target.closest(
				'.menu-item__link--depth-0, ' +
				'.menu-item__label--depth-0'
			);

			if (
				!control
				|| !mobileMenu.contains(control)
			) {
				return;
			}

			const item = control.closest(
				'.menu-item--depth-0'
			);

			if (!item) {
				return;
			}

			const subMenu = getSubMenu(item);

			/*
			* Regular link without submenu:
			* do nothing and allow native <a> navigation.
			*/
			if (!subMenu) {
				return;
			}

			/*
			* Only submenu controls should block navigation.
			*/
			event.preventDefault();
			event.stopPropagation();

			const willOpen = !item.classList.contains(
				'is-open'
			);

			closeOtherItems(item);

			item.classList.toggle(
				'is-open',
				willOpen
			);

			control.setAttribute(
				'aria-expanded',
				String(willOpen)
			);
		},
		true
	);

	mobileMenu.addEventListener('close', () => {
		items.forEach(closeItem);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener(
		'DOMContentLoaded',
		initMobileMenuAccordion
	);
} else {
	initMobileMenuAccordion();
}